import cn from "@/v2-ui/utils/utils.cn"
import Badge, { type BadgeProps } from "@/v2-backoffice-client/components/badge"
import {
  getStatusBadgeVariant,
  getStatusDescription,
} from "@/v2-backoffice-client/invitation/log/invitation.log.utils"
import type { InvitationLogFragment } from "@/v2-backoffice-client/invitation/log/__types__/invitation.log.fragment"

export type InvitationLogStatusProps = BadgeProps & {
  log: InvitationLogFragment | null | undefined
}

function InvitationLogStatus(props: InvitationLogStatusProps) {
  const { log, className, ...badgeProps } = props
  const variant = getStatusBadgeVariant(log?.StatusCode)
  const description = getStatusDescription(log?.StatusCode)
  return (
    <Badge
      className={cn("inline-block", className)}
      variant={variant}
      size="xs"
      tooltip={description}
      {...badgeProps}
    >
      {log ? log.StatusName || `Status ${log.StatusCode}` : "..."}
    </Badge>
  )
}

export default InvitationLogStatus
